<template>
  <div class="header-pub clearfix">
    <div class="main-con logo clearfix">
      <div class="fxl img"><img src="../assets/logo.jpg"></div>
      <div class="fxr time">{{ dateFormat(newDate) }}</div>
    </div>
    <div class="menu clearfix">
      <div class="main-con clearfix">
        <ul class="clearfix">
          <li v-for="(item, index) in daohcdList" :key="index" :class="{'focus':index==tabSelect}"
              class="fxl" @click="jump(item.value,index)" :style="{width:`${100/daohcdList.length}%`}">
            {{ item.text }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props:{
    tabSelect:{
      type:Number,
      default: 0
    }
  },
  data() {
    return {
      newDate: new Date(),
      daohcdList: [],
      timer: null,
    };
  },
  // 注入全局变量
  inject: ["imageUrl", "serviceUrl"],
  mounted() {
    let that = this;
    this.timer = setInterval(() => {
      that.newDate = new Date() // 修改数据date
    }, 1000)
    axios
        .get(that.serviceUrl + "/sys/api/queryDictItemsByCode", {
          params: {code: "daohcd"},
        })
        .then((resp) => {
          console.log(resp);
          that.daohcdList = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
  },

  methods: {
    jump(path) {
      this.$router.push(path);
    },
    dateFormat(time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let wk = date.getDay()
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      // let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
      let week = weeks[wk]
      // 拼接
      return year + "年" + month + "月" + day + "日" + " " + hours + ":" + minutes + " " + week
    },
  },
};
</script>

<style lang="less" scoped>
.header-pub {
  .logo {
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .img {
      width: 50%;

      img {
        height: 100px;
      }
    }

    .time {
      font-size: 18px;
      color: #a4a4a4;
      width: 50%;
      text-align: right;
    }
  }
  .menu{
    border-top: 1px solid #dadada;
    ul{
      margin:0px 0px 20px 0px;
      border-bottom: 5px solid #eee222;
      line-height:40px;
      text-align: center;
      color:#fff;
      font-size:16px;
      font-weight: bold;
      li{
        cursor: pointer;
        background:#c72a23;
        &.focus{
          color:#eee222;
        }
        &:nth-child(2){
          background:#469fe4;
        }
        &:nth-child(3){
          background:#5abd38;
        }
        &:nth-child(4){
          background:#d1a538;
        }
        &:nth-child(5){
          background:#6235be;
        }
        &:nth-child(6){
          background:#b53eb0;
        }
      }
    }
  }
}
</style>
